export const maintenanceGuard = async (to) => {
  if (to.name === 'Maintenance') {
    return null;
  }

  try {
    const maintenanceService = (await import('@/services/maintenanceService')).default;
    const inMaintenance = await maintenanceService.isInMaintenance();


    if (inMaintenance) {
      const hasValidBypass = maintenanceService.hasValidatedBypass();

      if (!hasValidBypass) {
        return { name: 'Maintenance' };
      }

    }
  } catch (error) {
    console.error('[Router] Error verificando mantenimiento:', error);
  }

  return null;
};
